import React from 'react';
import './style_contrato.css';

interface CardDetalheContratoProps {
    data: any;
}

const CardDetalheContrato = ({ data }: CardDetalheContratoProps) => {
    if (!data) {
        return (
            <div className="card-detalhe-contrato">
                <div className="card-detalhe-contrato-header">
                    <div className="card-detalhe-contrato-header-title">Overview</div>
                </div>
                <div className="card-detalhe-contrato-body">
                    <div className="card-detalhe-contrato-body-content">
                        <div className="text-center text-muted">
                            Nenhum dado disponível
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    
    return (
        <div className="card-detalhe-contrato">
            <div className="card-detalhe-contrato-header">
                <div className="card-detalhe-contrato-header-title">Overview</div>
            </div>
            <div className="card-detalhe-contrato-body">
                <div className="card-detalhe-contrato-body-content">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">ID da transação:</div>
                            <div className="card-detalhe-contrato-body-value">{data.id}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Valor de aquisição:</div>
                            <div className="card-detalhe-contrato-body-value">{data.valor_aquisicao}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Valor nominal:</div>
                            <div className="card-detalhe-contrato-body-value">{data.valor_nominal}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Taxa de emissão do contrato:</div>
                            <div className="card-detalhe-contrato-body-value">{data.taxa_contrato}</div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Data de emissão:</div>
                            <div className="card-detalhe-contrato-body-value">{data.data_emissao}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Vencimento máximo:</div>
                            <div className="card-detalhe-contrato-body-value">{data.vencimento_maximo}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Vencimento mínimo:</div>
                            <div className="card-detalhe-contrato-body-value">{data.vencimento_minimo}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="card-detalhe-contrato-body-title">Qtd. Parcelas:</div>
                            <div className="card-detalhe-contrato-body-value">{data.qtd_parcelas}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardDetalheContrato;